//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userSignin from '~/components/login/userSigin.vue'
import userDealer from '~/components/login/userDealer.vue'
import userRegister from '~/components/login/userRegister.vue'
import userReset from '~/components/login/userReset.vue'
import userQrcode from '~/components/login/userQrcode.vue'
import userMpopup from '~/components/login/userMpopup.vue' // 移动端登录弹框
import { getMyCountry } from '~/assets/js/utils.js'
export default {
  components: {
    'user-sigin': userSignin,
    'user-reset': userReset,
    'user-register': userRegister,
    'user-qrcode': userQrcode,
    'user-dealer': userDealer,
    'user-mpopup': userMpopup
  },
  data () {
    return {
      loginCode: 1, // 1.手机号+验证码，2.注册，3.重置
      phone: '', // 用户输入的手机号
      verifCode: '', // 用户输入的验证码
      requestId: '', // 登录极验id
      mobileVisible: false // 移动端登录是否展示
    }
  },
  computed: {
    // 是否为移动端
    isM () {
      return this.$store.state?.isMobile
    },
    title () {
      return this.loginCode != 2 ? this.$t('TYY_000262') : this.$t('22512') // 不等于2时->验证码，等于2时->注册
    },
    voiceTitle () {
      return this.loginCode != 2 ? this.$t('22573') : this.$t('22512') // 不等于2时->语音验证，等于2时->注册
    }
  },
  watch: {
    // 搜索后的列表
    close () {
      this.loginCode = 1
    }
  },
  created () {
    const obj = getMyCountry({ countryCode: this.$store.state?.countryCode || '840' })
    this.$store.commit('setVal', { phoneInfo: obj })
    this.loginCode = (this.$route.query?.type == 'register' ? 2 : 1)
  },
  methods: {
    // 关闭登录弹框
    close () {
      this.$store.commit('setVal', { loginShow: false })
      this.loginCode = 1 // 切换为账号/手机登录
      this.phone = this.verifCode = this.requestId = ''
      this.mobileVisible = false
    },
    // 切换登录方式
    loginSwitch (value = 1) {
      this.loginCode = value
    },
    // 移动端切换登录方式
    loginMswitch (value = 1) {
      this.mobileVisible = true
      this.loginCode = value
    },
    // 获取用户输入的手机号
    cellphoneNumber (value = '') {
      this.phone = value
    },
    // 获取用户输入的验证码
    verCode (value = '') {
      this.verifCode = value
    },
    // 获取登录未注册传进来的id
    getRequestId (value = '') {
      this.requestId = value
    }
  }
}
